module.exports = __webpack_public_path__ + "assets/img/Main material (12).0a6970db.jpg";